import { useNavigate } from 'react-router-dom'
import { useSystemStateHooks } from '../../../../modules/system'
import { useBookmarkActions } from '../../hooks/useBookmarkActions'
import { BOOKMARK_ICONS } from '../../bookmarkLabels'

export const MobileBookmarksNav = () => {
    const { bookmarks } = useBookmarkActions()
    const { companyCode } = useSystemStateHooks()
    const navigate = useNavigate()

    return (
        <li className="nav-item dropdown pe-3 d-flex d-lg-none">
            <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                data-bs-toggle="dropdown"
                href="#"
                onClick={e => e.preventDefault()}
            >
                <i className="bi bi-star-fill" style={{ color: '#6d9791' }} />
                <span className="dropdown-toggle ps-2">Favoritos</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                {bookmarks.length === 0 ? (
                    <li>
                        <span className="dropdown-item text-muted" style={{ fontSize: '0.85rem', cursor: 'default' }}>
                            Sin favoritos guardados
                        </span>
                    </li>
                ) : bookmarks.map(bookmark => (
                    <li key={bookmark.routePath}>
                        <button
                            type="button"
                            className="dropdown-item d-flex align-items-center gap-2"
                            onClick={() => navigate(`/${companyCode}/${bookmark.routePath}`)}
                        >
                            <i className={`bi bi-${BOOKMARK_ICONS[bookmark.routePath] || 'star-fill'}`} style={{ color: '#6d9791', fontSize: '0.85rem' }} />
                            <span>{bookmark.label}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </li>
    )
}
